// extracted by mini-css-extract-plugin
export default {"leftContainer":"Styles_leftContainer__WFEIu","rightContainer":"Styles_rightContainer__8IqMZ","notification":"Styles_notification__CLqjr"};